import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoadingService } from '../../../services/loading/loading.service';

@Component({
  selector: 'app-custom-progress-spinner',
  templateUrl: './custom-progress-spinner.component.html',
  styleUrls: ['./custom-progress-spinner.component.scss'],
  standalone: true,
  imports: [ProgressSpinnerModule, CommonModule],
})
export class CustomProgressSpinnerComponent implements OnInit {

  isLoading = this.loadingService.isLoading;
  constructor(private loadingService: LoadingService) {}

  ngOnInit() {
  }

}
